<template>
  <!--언어 선택-->
  <div class="contents-wrap">
    <div
      class="dropdown-trigger"
      ref="triggerLanRef"
      @click="toggleDropdown"
      :class="{
        active: showDropdown,
        'input-error': isVisibleErrorLanguage,
      }"
    >
      <p>
        {{ languageSelected ? languageSelected.name : t('label_language') }}
      </p>
      <component
        class="icon-medium icon-default icon-dropdown"
        :is="showDropdown ? ChevronUpIcon : ChevronDownIcon"
      />
    </div>
    <div v-if="isVisibleErrorLanguage" class="error-message">
      <InfoIcon class="icon-smaller icon-error" />
      <p class="small error">{{ t('error_input_no_language') }}</p>
    </div>
    <Dropdown
      v-if="showDropdown"
      position="below"
      :trigger-ref="triggerLanRef"
      :class="{ active: showDropdown }"
      @close="closeDropdown"
    >
      <LanguageList
        :showAllInList="true"
        :selected-at-top="true"
        is-modal
        is-using-language-detection
        @select="changeLanguage"
      />
    </Dropdown>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import ChevronDownIcon from '@/components/icons/IconChevronDown.vue';
import ChevronUpIcon from '@/components/icons/IconChevronUp.vue';
import InfoIcon from '@/components/icons/IconInfo.vue';
import Dropdown from '@/components/shared/base/Dropdown.vue';
import LanguageList from '@/components/shared/base/LanguageList.vue';
import { useAudioStore } from '@/stores/audio';
import { useUserStore } from '@/stores/user';
import { Language } from '@/types/components';

const { t } = useI18n();

const audioStore = useAudioStore();
const userStore = useUserStore();

const {} = defineProps<{}>();

const languageSelected = defineModel<Language>('languageSelected');
const isVisibleErrorLanguage = defineModel('isVisibleErrorLanguage');

const showDropdown = ref(false);
const triggerLanRef = ref();
const dropdownContainerRef = ref<HTMLElement>();

const changeLanguage = (language) => {
  isVisibleErrorLanguage.value = false;
  audioStore.selectLanguage(language.code);
  languageSelected.value = language;
  showDropdown.value = false;
};

const closeDropdown = () => {
  showDropdown.value = false;
};

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
  if (showDropdown.value) {
    document.addEventListener('click', handleClickOutside);
  } else {
    document.removeEventListener('click', handleClickOutside);
  }
};

const handleClickOutside = (event) => {
  if (
    dropdownContainerRef.value &&
    !dropdownContainerRef.value.contains(event.target)
  ) {
    closeDropdown();
  }
};
</script>

<style scoped lang="scss">
.contents-wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.25rem;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  white-space: nowrap;
}

/* 드랍다운 스타일 */
.dropdown-trigger {
  display: flex;
  width: 100%;
  gap: 0.5rem;
  justify-content: center;
  padding: 0.75rem;
  background-color: var(--surface-gray-dimmer);
  color: var(--font-default);
  border-radius: 8px;
  cursor: pointer;
}

.dropdown-trigger:hover,
.dropdown-trigger:active,
.dropdown-trigger.active {
  background-color: var(--surface-hover-gray-dimmer);
}

::v-deep(.dropdown-content) {
  width: 77dvw;
  max-width: 22.5rem;
}

::v-deep(.language-content) {
  max-height: 12rem;
}

.icon-dropdown {
  position: absolute;
  right: 1rem;
  flex-shrink: 0;
}

.error-message {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  fill: var(--error);
  color: var(--error);
  gap: 0.25rem;
}

::v-deep(.dropdown-content) {
  position: absolute;
  top: 11.25rem !important;
  left: 50% !important; 
  transform: translate(-50%);
  min-width: unset;
  width: 77dvw;
  max-width: 22.5rem;
}
</style>
